module.exports = ".back-ground{\r\n    background-color: black;\r\n    width: 100%;\r\n    /* height: 50px; */\r\n}\r\n.back-ground .container{\r\n    padding-top: 11px;\r\n}\r\n.back-ground label{\r\n    color: white;\r\n}\r\n@media print {\r\n    .header, .navbar, #u-menu, .back-ground{\r\n        display: none !important;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/all-opened-tickets/all-opened-tickets.component.css
// module id = ./src/app/reports/all-opened-tickets/all-opened-tickets.component.css
// module chunks = main